import { AnsweringClient, IInstrument } from "../../clients/answeringClient";

export interface CreateAssignmentModalControllerDelegate {
  didGetInstruments: (assignments: IInstrument[]) => void;
  didCreateAssignment: (assignmentId: number, payload: { name: string; instrumentId: number; dueDate: Date }) => void;
  applicationShouldLogout: () => void;
  genericError: () => void;
}

export class CreateAssignmentModalController {
  constructor(
    private delegate: CreateAssignmentModalControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  public async getManagedInstruments(accessToken: string) {
    try {
      const response = await this.answeringClient.getAllManagedInstruments(
        accessToken
      );
      this.delegate.didGetInstruments(response.data);
    } catch (error: any) {
      if (error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        this.getManagedInstruments(newTokens.accessToken);
        return;
      }
      this.delegate.genericError();
    }
  }

  public async createAssignment(
    accessToken: string,
    dueDate: Date,
    instrumentId: number,
    name: string
  ) {
    try {
      const response = await this.answeringClient.createAssignment(
        accessToken,
        dueDate,
        instrumentId,
        name
      );
      const result = response.data as { applicationId?: number } | undefined;
      const assignmentId = result?.applicationId;
      this.delegate.didCreateAssignment(assignmentId ?? 0, {
        name,
        instrumentId,
        dueDate,
      });
    } catch (error: any) {
      if (error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        this.createAssignment(
          newTokens.accessToken,
          dueDate,
          instrumentId,
          name
        );
        return;
      }
      this.delegate.genericError();
    }
  }

  private async refreshTokens(): Promise<{
    accessToken: string;
    refreshToken: string;
  } | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: { accessToken: string; refreshToken: string } =
        response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }
}
